
const LOCAL_STORAGE_KEYS = {
    CLIENT_KEY: 'CLIENT_KEY',
    TOKEN: 'API_TOKEN',
};

//TODO: move to react-app
const saveToLocalStorage = ({ key, value, useJson = false }) => {
    localStorage.setItem(key, useJson ? JSON.stringify(value) : value);
};

const getFromLocalStorage = ({ key, useJson = false }) => {
    const data = localStorage.getItem(key);
    return data ? useJson ? JSON.parse(data) : data : null;
};

export {
    LOCAL_STORAGE_KEYS,
    saveToLocalStorage,
    getFromLocalStorage
}
